import { h, Fragment } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function AppLayout({ children }) {
    return html`
        <${Fragment}>
            <header id="main-header" style="display: none;">
                <div class="header-left">
                    <button id="hamburger-btn" class="icon-btn">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                            <path fill="currentColor" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                        </svg>
                    </button>
                    <h1>Cogrity</h1>
                </div>
                <div class="header-right">
                    <button id="user-menu-btn" class="icon-btn">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                            <path
                                fill="currentColor"
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
                            />
                        </svg>
                    </button>
                    <div id="user-dropdown" class="dropdown-menu">
                        <a href="#/settings" id="nav-settings">Account Settings</a>
                        <a href="#" id="nav-logout">Logout</a>
                    </div>
                </div>
            </header>

            <nav id="sidebar" class="sidebar">
                <a href="#/dashboard" id="nav-dashboard" class="active">Dashboard</a>
                <a href="#/schedule" id="nav-schedule">Scheduling</a>
                <a href="#/groups" id="nav-groups">Groups</a>
                <a href="#/sessions" id="nav-sessions">Sessions</a>
                <a href="#/cards" id="nav-cards">Cards</a>
            </nav>

            <div id="sidebar-overlay" class="overlay"></div>

            <main id="main-content">
                <div id="message" class="message"></div>
                ${children}
            </main>

            <nav id="bottom-nav" class="bottom-nav">
                <a href="#/dashboard" id="bnav-dashboard" class="b-nav-item active">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                        <path fill="currentColor" d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
                    </svg>
                    <span>Home</span>
                </a>
                <a href="#/schedule" id="bnav-schedule" class="b-nav-item">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                        <path
                            fill="currentColor"
                            d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8 8-8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                        />
                    </svg>
                    <span>Scheduling</span>
                </a>
                <a href="#/groups" id="bnav-groups" class="b-nav-item">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                        <path
                            fill="currentColor"
                            d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                        />
                    </svg>
                    <span>Groups</span>
                </a>
                <a href="#/cards" id="bnav-cards" class="b-nav-item">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                        <path
                            fill="currentColor"
                            d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H4V4h16v12zM4 20h16v2H4z"
                        />
                    </svg>
                    <span>Cards</span>
                </a>
                <a href="#/settings" id="bnav-settings" class="b-nav-item">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                        <path
                            fill="currentColor"
                            d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                        />
                    </svg>
                    <span>Settings</span>
                </a>
            </nav>
        </${Fragment}>
    `;
}
